@if (isOpen()) {
  <nf-dialog
    [title]="'adminAdminHubModal.title' | transloco"
    size="lg"
    [showFooter]="false"
    (closed)="onCloseRequested()">
    <div class="py-4">
      <sk-category-card-grid
        [items]="cards()"
        [columns]="2"
        iconSize="md"
        (cardClick)="onCardClick($event)" />
    </div>
  </nf-dialog>
}
